/** @format */

import React, { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import './BoardItem.css';

const BoardItem = ({
  writer,
  title,
  content,
  postId,
  writeDate,
  board,
  commentCount,
}) => {
  const navigate = useNavigate();

  const goDetail = () => {
    navigate(`/Board/${postId}`);
  };

  const isPc = useMediaQuery({
    query: '(min-width: 768px)',
  });

  const date = writeDate.split('T')[0];

  return (
    <div onClick={goDetail}>
      {isPc ? (
        <div className="Info">
          <div className="ItemNum">{postId}</div>
          <div className="ItemTitle">{title}</div>
          <div className="ItemContent">{content}</div>
          <div className="ItemWriter">{writer}</div>
          <div className="ItemDate">{date}</div>
          <div className="ItemComment">{commentCount}</div>
        </div>
      ) : (
        <div className="Info">
          <div className="ItemTop">
            <div className="ItemNum">{postId}</div>
            <div className="ItemTitle">{title}</div>
          </div>
          <div className="ItemBottom">
            <div className="ItemWriter">{writer}</div>
            <div className="ItemDate">{date}</div>
            <div className="ItemComment">{commentCount}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BoardItem;
